import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import fr from './fr.json';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const detection = {
  order: ['path'],
  lookupFromPathIndex: 0
}

const resources = {
  en: {
    translation: {
      ...en
    }
  },
  fr: {
    translation: {
      ...fr
    }
  }
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: detection,
    fallbackLng: 'en',
    resources,
    supportedLngs: ['en', 'fr'],
    interpolation: {
      escapeValue: false,
      prefix: '{{',
      suffix: '}}',
      skipOnVariables: false
    }
  });

export default i18n;
